import { useState } from "react";
import { IContact } from "../../Contact.props";
import ApiService from "../../../../../service/ApiService";
import { apiPaths } from "../../../../../service/apiPaths";
import { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const useContact = () => {
  const navigate = useNavigate();
  const [contactData, setContactData] = useState<IContact>({} as IContact);
  const [loading, setLoading] = useState(false);
  const [interest, setInterest] = useState<any[]>([]);
  const [interestId, setInterestId] = useState<string>("");
  const [services, setServices] = useState<any[]>([]);
  const [serviceId, setServiceId] = useState<string>("");
  const [outputStatuses, setOutputStatuses] = useState<any[]>([]);
  const [outputStatusId, setOutputStatusId] = useState<string>("");
  const [platforms, setPlatforms] = useState<any[]>([]);
  const [platformId, setPlatformId] = useState<string>("");

  const fetchInterestsData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({ method: "GET", endpoint: apiPaths.interests });
      setInterest(result);
      if (result.length > 0) setInterestId(result[0].id);
    } catch (error) {
      console.error("Error fetching interests:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchServicesData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({ method: "GET", endpoint: apiPaths.services });
      setServices(result);
      if (result.length > 0) setServiceId(result[0].id);
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOutputStatusesData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({ method: "GET", endpoint: apiPaths.outputStatus });
      setOutputStatuses(result);
      if (result.length > 0) setOutputStatusId(result[0].id);
    } catch (error) {
      console.error("Error fetching output statuses:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPlatformsData = async () => {
    setLoading(true);
    try {
      const result = await ApiService({ method: "GET", endpoint: apiPaths.platforms });
      setPlatforms(result);
      if (result.length > 0) setPlatformId(result[0].id);
    } catch (error) {
      console.error("Error fetching platforms:", error);
    } finally {
      setLoading(false);
    }
  };

  // Submit handler
  const handleSubmit: SubmitHandler<IContact> = async (data) => {
    try {
      setLoading(true);
      console.log("Submitting form data:", data); // 🔍 Debugging
      await ApiService({
        method: "POST",
        endpoint: apiPaths.contactCreate,
        data: {
          ...data,
          interest: interestId,
          services: serviceId,
          outputStatus: outputStatusId,
          platform: platformId,
          billingInfo: {
            currency: data.billingInfo?.currency || "USD",
          },
          contractDetails: {
            contractType: data.contractDetails?.contractType || "Fixed",
          },
        },
      });
      navigate("/contact");
    } catch (error) {
      console.error("Error creating contact:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    contactData,
    loading,
    interest,
    interestId,
    services,
    serviceId,
    outputStatuses,
    outputStatusId,
    platforms,
    platformId,
    setContactData,
    handleSubmit,
    setInterestId,
    setServiceId,
    setOutputStatusId,
    setPlatformId,
    fetchInterestsData,
    fetchServicesData,
    fetchOutputStatusesData,
    fetchPlatformsData,
  };
};

export default useContact;
